export default __webpack_public_path__ + "static/koiwasyou-931efed1cab86fe6004f69e31e3fa3a6.jpg";